const Footer = ({ data: { titles, links } }) => {
    return (
        <>
            <div className="grid grid-cols-3 gap-x-2 md:gap-x-5 justify-between py-2 md:w-[700px]">
                {
                    titles.map((item, index) => {
                        return <h2 className="text-[16px] font-semibold" key={index}>{item.title}</h2>
                    })
                }
                {
                    links.map((item, index) => {
                        return <ul className="mt-2" key={index}>
                            {
                                item.map((i, index) => {
                                    return <li className="text-[12px] text-white md:text-[14px]" key={index}><a href="">{i.link}</a></li>
                                })
                            }
                        </ul>
                    })
                }

            </div>
        </>
    )
}
export default Footer;